
import * as THREE from 'three';

export function generateScene(){
    let scene = new THREE.Scene();
    scene.background = new THREE.Color(0xffffff);
    scene.add(new THREE.AxesHelper(2));

    
    const directionx = new THREE.Vector3(1, 0, 0); // 箭头方向（这里是 X 轴正方向）
    const directiony = new THREE.Vector3(0, 1, 0); // 箭头方向（这里是 Y 轴正方向）
    const directionz = new THREE.Vector3(0, 0, 1); // 箭头方向（这里是 Z 轴正方向）
    const origin = new THREE.Vector3(0, 0, 0);    // 箭头起点（这里是世界坐标系原点）
    const length = 3;                             // 箭头总长度
    const colorx = 0xff0000;                       // 箭头颜色（红色）
    const colory = 0x00ff00;                       // 箭头颜色（绿色）
    const colorz = 0x0000ff;                       // 箭头颜色（蓝色）
    const headLength = 0.3;                         // 箭头头部长度（默认是总长度的 1/5）
    const headWidth = 0.1;                        // 箭头头部宽度（默认是头部长度的 2/3）

    // 1. 添加X轴
    let arrowX = new THREE.ArrowHelper(
        directionx,  // 方向向量（必须是归一化向量，否则可能拉伸）
        origin,     // 起点位置
        length,     // 总长度
        colorx,      // 整体颜色（可选，默认 0xffff00 黄色）
        headLength, // 箭头头部长度（可选）
        headWidth   // 箭头头部宽度（可选）
      );
    arrowX.userData.isBloom = false; // 明确标记不发光
    scene.add(arrowX);
    
    // 2. 添加Y轴
    scene.add(new THREE.ArrowHelper(
        directiony, origin, length, colory, headLength, headWidth 
    ));
    
    // 3. 添加z轴
    scene.add(new THREE.ArrowHelper(
        directionz, origin, length, colorz, headLength, headWidth 
    ));

    return scene;
}

